import {observer} from "mobx-react";
import Currency from "../../../components/currency/currency";
import {FontBody1} from "../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../components/fonts/font-body2/font-body2";
import FontHeading2 from "../../../components/fonts/font-heading2/font-heading2";
import {FONT_COLOR, FONT_VARIANT} from "../../../components/fonts/font-props";
import IconInfo from "../../../components/icons/icon-info/icon-info";
import Icon from "../../../components/icons/icon/icon";
import {Textarea, TEXTAREA_VARIANTS} from "../../../components/inputs/textarea/textarea";
import Card from "../../../components/layouts/card/card";
import './summary-card.scss';
import ListLayout from "../../../components/layouts/list-layout/list-layout";
import {Tooltip} from "../../../components/tooltip/tooltip";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaRequestStore from "../stores/rma-request-store";

interface IProps {
	rmaRequestStore: RmaRequestStore;
}

const SummaryCard: React.FC<IProps> = observer(({ rmaRequestStore}) => {
    
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
	if(!rmaRequestStore.requestProducts.length){
		return <></>;
	}

	return (
		<div className={'createrma-summary-card'}>
			<ListLayout>
				<FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.PRIMARY2}>{getTranslation('SUMMARY', pageScope)}</FontHeading2>
				<Card>
					
					<div className={'summary-grid'}>
                        
                        <div>
						    <FontBody1>{getTranslation('ITEMS_SUBTOTAL', pageScope)}</FontBody1>
							<FontBody1 variant={FONT_VARIANT.BOLD}>
                                <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.itemsSubtotal}/>
                            </FontBody1>
                        </div>
                        { rmaRequestStore.itemsAdjustments !== 0 &&
                            <div>
                                <FontBody1>{getTranslation('ADJUSTMENTS', pageScope)}</FontBody1>
                                <FontBody1 variant={FONT_VARIANT.BOLD}>
                                    <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.itemsAdjustments}/>
                                </FontBody1>
                            </div>
                        }
                        { rmaRequestStore.restockingFeeTotal < 0 &&
                            <div>
                                <FontBody1>{getTranslation('RESTOCKING_FEE_TOTAL', pageScope)}</FontBody1>
                                <FontBody1 variant={FONT_VARIANT.BOLD}>
                                    <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.restockingFeeTotal}/>
                                </FontBody1>
                            </div>
                        }
						{ rmaRequestStore.rmaFeesListStore.returnFee.isCharged &&
							<div>
								<FontBody1>{getTranslation('RETURN_FEE', pageScope)}</FontBody1>
								<FontBody1 variant={FONT_VARIANT.BOLD}>
                                    <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.getFeeSummary('returnFee')}/>
                                </FontBody1>
							</div>
						}
						{ rmaRequestStore.rmaFeesListStore.labelFee.isCharged &&
							<div>
								<FontBody1>{getTranslation('LABEL_FEE', pageScope)}</FontBody1>
								<FontBody1 variant={FONT_VARIANT.BOLD}>
                                    { !rmaRequestStore.isDynamicShippingOptionsSupported() && rmaRequestStore.doesLabelFeeIncludeCost() ?
                                      <Tooltip content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}><span dangerouslySetInnerHTML={{__html:getTranslation('FEE_CALCULATED_ON_CREATE', pageScope)}}></span></FontBody2>}>
                                          <Icon Component={IconInfo}/>
                                      </Tooltip>
                                       : <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.getFeeSummary('labelFee')}/>
                                    }
                                </FontBody1>
                            </div>
						}
                        <div>
                            <FontBody1>
                                { rmaRequestStore.total > 0
                                    ? getTranslation('TOTAL_TO_REFUND', pageScope)
                                    : getTranslation('TOTAL_TO_PAY', pageScope)
                                }
                            </FontBody1>
                            <FontBody1 variant={FONT_VARIANT.BOLD}>
                                <Currency currencyCode={rmaRequestStore.paymentCurrencyCode} amount={rmaRequestStore.total} absoluteNumber={true}/>
                            </FontBody1>
                        </div>
					</div>
					
                    <div className={'displayNote'}>
                        <Textarea value={rmaRequestStore.note}
                                  onChange={rmaRequestStore.setNote}
                                  variant={TEXTAREA_VARIANTS.DEFAULT}
                                  placeholder={getTranslation('NOTE_PLACEHOLDER', pageScope)}
                        />
                    </div>
					
				</Card>
			</ListLayout>
		</div>
	)
});

export default SummaryCard;